export default [
	{
		id: 129150330,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMjkxNTAzMzA=',
		name: '100-days-of-code',
		full_name: 'krittiyaclark/100-days-of-code',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/100-days-of-code',
		description:
			'Fork this template for the 100 days journal - to keep yourself accountable (multiple languages available)',
		fork: true,
		url: 'https://api.github.com/repos/krittiyaclark/100-days-of-code',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/100-days-of-code/deployments',
		created_at: '2018-04-11T20:28:37Z',
		updated_at: '2018-04-11T20:28:39Z',
		pushed_at: '2018-04-10T07:58:06Z',
		git_url: 'git://github.com/krittiyaclark/100-days-of-code.git',
		ssh_url: 'git@github.com:krittiyaclark/100-days-of-code.git',
		clone_url: 'https://github.com/krittiyaclark/100-days-of-code.git',
		svn_url: 'https://github.com/krittiyaclark/100-days-of-code',
		homepage: 'http://www.100daysofcode.com',
		size: 52,
		stargazers_count: 0,
		watchers_count: 0,
		language: null,
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 99767752,
		node_id: 'MDEwOlJlcG9zaXRvcnk5OTc2Nzc1Mg==',
		name: 'aos',
		full_name: 'krittiyaclark/aos',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/aos',
		description: 'Animate on scroll library',
		fork: true,
		url: 'https://api.github.com/repos/krittiyaclark/aos',
		forks_url: 'https://api.github.com/repos/krittiyaclark/aos/forks',
		keys_url: 'https://api.github.com/repos/krittiyaclark/aos/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/aos/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/aos/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/aos/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/aos/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/aos/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/aos/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/aos/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/aos/tags',
		blobs_url: 'https://api.github.com/repos/krittiyaclark/aos/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/aos/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/aos/git/refs{/sha}',
		trees_url: 'https://api.github.com/repos/krittiyaclark/aos/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/aos/statuses/{sha}',
		languages_url: 'https://api.github.com/repos/krittiyaclark/aos/languages',
		stargazers_url: 'https://api.github.com/repos/krittiyaclark/aos/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/aos/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/aos/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/aos/subscription',
		commits_url: 'https://api.github.com/repos/krittiyaclark/aos/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/aos/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/aos/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/aos/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/aos/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/aos/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/aos/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/aos/{archive_format}{/ref}',
		downloads_url: 'https://api.github.com/repos/krittiyaclark/aos/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/aos/issues{/number}',
		pulls_url: 'https://api.github.com/repos/krittiyaclark/aos/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/aos/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/aos/notifications{?since,all,participating}',
		labels_url: 'https://api.github.com/repos/krittiyaclark/aos/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/aos/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/aos/deployments',
		created_at: '2017-08-09T05:19:56Z',
		updated_at: '2017-08-09T05:19:57Z',
		pushed_at: '2017-08-08T18:22:43Z',
		git_url: 'git://github.com/krittiyaclark/aos.git',
		ssh_url: 'git@github.com:krittiyaclark/aos.git',
		clone_url: 'https://github.com/krittiyaclark/aos.git',
		svn_url: 'https://github.com/krittiyaclark/aos',
		homepage: null,
		size: 1084,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: {
			key: 'mit',
			name: 'MIT License',
			spdx_id: 'MIT',
			url: 'https://api.github.com/licenses/mit',
			node_id: 'MDc6TGljZW5zZTEz',
		},
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 276132860,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNzYxMzI4NjA=',
		name: 'beach-resort-react',
		full_name: 'krittiyaclark/beach-resort-react',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/beach-resort-react',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/beach-resort-react',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/beach-resort-react/deployments',
		created_at: '2020-06-30T15:06:38Z',
		updated_at: '2020-07-04T14:15:56Z',
		pushed_at: '2020-07-04T14:15:54Z',
		git_url: 'git://github.com/krittiyaclark/beach-resort-react.git',
		ssh_url: 'git@github.com:krittiyaclark/beach-resort-react.git',
		clone_url: 'https://github.com/krittiyaclark/beach-resort-react.git',
		svn_url: 'https://github.com/krittiyaclark/beach-resort-react',
		homepage: null,
		size: 2551,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 180647949,
		node_id: 'MDEwOlJlcG9zaXRvcnkxODA2NDc5NDk=',
		name: 'Blog-Post-React',
		full_name: 'krittiyaclark/Blog-Post-React',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Blog-Post-React',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Blog-Post-React',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/Blog-Post-React/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Blog-Post-React/deployments',
		created_at: '2019-04-10T19:15:14Z',
		updated_at: '2019-04-16T11:11:15Z',
		pushed_at: '2020-06-06T14:42:01Z',
		git_url: 'git://github.com/krittiyaclark/Blog-Post-React.git',
		ssh_url: 'git@github.com:krittiyaclark/Blog-Post-React.git',
		clone_url: 'https://github.com/krittiyaclark/Blog-Post-React.git',
		svn_url: 'https://github.com/krittiyaclark/Blog-Post-React',
		homepage: null,
		size: 534,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 6,
		license: null,
		forks: 0,
		open_issues: 6,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 268209606,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNjgyMDk2MDY=',
		name: 'bloom',
		full_name: 'krittiyaclark/bloom',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/bloom',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/bloom',
		forks_url: 'https://api.github.com/repos/krittiyaclark/bloom/forks',
		keys_url: 'https://api.github.com/repos/krittiyaclark/bloom/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/bloom/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/bloom/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/bloom/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/bloom/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/bloom/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/bloom/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/bloom/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/bloom/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/bloom/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/bloom/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/bloom/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/bloom/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/bloom/statuses/{sha}',
		languages_url: 'https://api.github.com/repos/krittiyaclark/bloom/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/bloom/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/bloom/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/bloom/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/bloom/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/bloom/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/bloom/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/bloom/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/bloom/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/bloom/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/bloom/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/bloom/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/bloom/{archive_format}{/ref}',
		downloads_url: 'https://api.github.com/repos/krittiyaclark/bloom/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/bloom/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/bloom/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/bloom/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/bloom/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/bloom/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/bloom/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/bloom/deployments',
		created_at: '2020-05-31T04:36:39Z',
		updated_at: '2020-06-06T04:12:44Z',
		pushed_at: '2020-06-06T04:13:32Z',
		git_url: 'git://github.com/krittiyaclark/bloom.git',
		ssh_url: 'git@github.com:krittiyaclark/bloom.git',
		clone_url: 'https://github.com/krittiyaclark/bloom.git',
		svn_url: 'https://github.com/krittiyaclark/bloom',
		homepage: null,
		size: 867,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 270048400,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNzAwNDg0MDA=',
		name: 'bloom-react',
		full_name: 'krittiyaclark/bloom-react',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/bloom-react',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/bloom-react',
		forks_url: 'https://api.github.com/repos/krittiyaclark/bloom-react/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/bloom-react/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/bloom-react/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/bloom-react/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/bloom-react/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/bloom-react/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/bloom-react/deployments',
		created_at: '2020-06-06T17:09:31Z',
		updated_at: '2020-06-17T04:24:19Z',
		pushed_at: '2020-07-21T04:10:42Z',
		git_url: 'git://github.com/krittiyaclark/bloom-react.git',
		ssh_url: 'git@github.com:krittiyaclark/bloom-react.git',
		clone_url: 'https://github.com/krittiyaclark/bloom-react.git',
		svn_url: 'https://github.com/krittiyaclark/bloom-react',
		homepage: null,
		size: 926,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 2,
		license: null,
		forks: 0,
		open_issues: 2,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 208678793,
		node_id: 'MDEwOlJlcG9zaXRvcnkyMDg2Nzg3OTM=',
		name: 'bootstrap-4-sass-gulp-4-boilerplate',
		full_name: 'krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate/deployments',
		created_at: '2019-09-16T00:42:36Z',
		updated_at: '2019-09-16T14:58:55Z',
		pushed_at: '2020-07-18T07:04:17Z',
		git_url:
			'git://github.com/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate.git',
		ssh_url:
			'git@github.com:krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate.git',
		clone_url:
			'https://github.com/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate.git',
		svn_url:
			'https://github.com/krittiyaclark/bootstrap-4-sass-gulp-4-boilerplate',
		homepage: null,
		size: 10194,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'CSS',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 3,
		license: {
			key: 'mit',
			name: 'MIT License',
			spdx_id: 'MIT',
			url: 'https://api.github.com/licenses/mit',
			node_id: 'MDc6TGljZW5zZTEz',
		},
		forks: 0,
		open_issues: 3,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 89173163,
		node_id: 'MDEwOlJlcG9zaXRvcnk4OTE3MzE2Mw==',
		name: 'Build-a-Random-Quote-Machine',
		full_name: 'krittiyaclark/Build-a-Random-Quote-Machine',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Build-a-Random-Quote-Machine',
		description: 'FreeCodeCamp Build a Random Quote Machine',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Build-a-Random-Quote-Machine/deployments',
		created_at: '2017-04-23T21:19:11Z',
		updated_at: '2017-06-18T03:48:36Z',
		pushed_at: '2017-05-05T03:35:26Z',
		git_url: 'git://github.com/krittiyaclark/Build-a-Random-Quote-Machine.git',
		ssh_url: 'git@github.com:krittiyaclark/Build-a-Random-Quote-Machine.git',
		clone_url:
			'https://github.com/krittiyaclark/Build-a-Random-Quote-Machine.git',
		svn_url: 'https://github.com/krittiyaclark/Build-a-Random-Quote-Machine',
		homepage: '',
		size: 51,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 134648710,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzQ2NDg3MTA=',
		name: 'Build-And-Learn-Budget-App',
		full_name: 'krittiyaclark/Build-And-Learn-Budget-App',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Build-And-Learn-Budget-App',
		description:
			'The Budget App builds with Vanilla JavaScript, Bootstrap. It is an app that you can calculate your expenses.',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Build-And-Learn-Budget-App/deployments',
		created_at: '2018-05-24T02:12:05Z',
		updated_at: '2018-06-22T19:10:23Z',
		pushed_at: '2018-06-22T19:10:22Z',
		git_url: 'git://github.com/krittiyaclark/Build-And-Learn-Budget-App.git',
		ssh_url: 'git@github.com:krittiyaclark/Build-And-Learn-Budget-App.git',
		clone_url:
			'https://github.com/krittiyaclark/Build-And-Learn-Budget-App.git',
		svn_url: 'https://github.com/krittiyaclark/Build-And-Learn-Budget-App',
		homepage: '',
		size: 913,
		stargazers_count: 2,
		watchers_count: 2,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 2,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 2,
		license: null,
		forks: 2,
		open_issues: 2,
		watchers: 2,
		default_branch: 'master',
	},
	{
		id: 91638939,
		node_id: 'MDEwOlJlcG9zaXRvcnk5MTYzODkzOQ==',
		name: 'Build.to.Learn.paypal.slack.team',
		full_name: 'krittiyaclark/Build.to.Learn.paypal.slack.team',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/Build.to.Learn.paypal.slack.team',
		description: 'Build to learn paypal slack',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Build.to.Learn.paypal.slack.team/deployments',
		created_at: '2017-05-18T02:15:12Z',
		updated_at: '2017-09-27T19:46:17Z',
		pushed_at: '2017-07-25T02:24:59Z',
		git_url:
			'git://github.com/krittiyaclark/Build.to.Learn.paypal.slack.team.git',
		ssh_url:
			'git@github.com:krittiyaclark/Build.to.Learn.paypal.slack.team.git',
		clone_url:
			'https://github.com/krittiyaclark/Build.to.Learn.paypal.slack.team.git',
		svn_url:
			'https://github.com/krittiyaclark/Build.to.Learn.paypal.slack.team',
		homepage: null,
		size: 16,
		stargazers_count: 1,
		watchers_count: 1,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 1,
		default_branch: 'master',
	},
	{
		id: 262683191,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNjI2ODMxOTE=',
		name: 'burger-builder',
		full_name: 'krittiyaclark/burger-builder',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/burger-builder',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/burger-builder',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/burger-builder/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/burger-builder/deployments',
		created_at: '2020-05-10T00:22:13Z',
		updated_at: '2020-05-22T13:11:56Z',
		pushed_at: '2020-05-22T13:11:53Z',
		git_url: 'git://github.com/krittiyaclark/burger-builder.git',
		ssh_url: 'git@github.com:krittiyaclark/burger-builder.git',
		clone_url: 'https://github.com/krittiyaclark/burger-builder.git',
		svn_url: 'https://github.com/krittiyaclark/burger-builder',
		homepage: null,
		size: 19856,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 129842444,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMjk4NDI0NDQ=',
		name: 'challenges',
		full_name: 'krittiyaclark/challenges',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/challenges',
		description: 'PyBites Code Challenges',
		fork: true,
		url: 'https://api.github.com/repos/krittiyaclark/challenges',
		forks_url: 'https://api.github.com/repos/krittiyaclark/challenges/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/challenges/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/challenges/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/challenges/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/challenges/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/challenges/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/challenges/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/challenges/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/challenges/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/challenges/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/challenges/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/challenges/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/challenges/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/challenges/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/challenges/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/challenges/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/challenges/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/challenges/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/challenges/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/challenges/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/challenges/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/challenges/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/challenges/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/challenges/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/challenges/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/challenges/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/challenges/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/challenges/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/challenges/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/challenges/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/challenges/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/challenges/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/challenges/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/challenges/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/challenges/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/challenges/deployments',
		created_at: '2018-04-17T03:46:27Z',
		updated_at: '2018-04-17T03:46:29Z',
		pushed_at: '2018-04-09T11:47:07Z',
		git_url: 'git://github.com/krittiyaclark/challenges.git',
		ssh_url: 'git@github.com:krittiyaclark/challenges.git',
		clone_url: 'https://github.com/krittiyaclark/challenges.git',
		svn_url: 'https://github.com/krittiyaclark/challenges',
		homepage: 'https://codechalleng.es/challenges/',
		size: 30216,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'Python',
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 254194247,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNTQxOTQyNDc=',
		name: 'clothing-store',
		full_name: 'krittiyaclark/clothing-store',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/clothing-store',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/clothing-store',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/clothing-store/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/clothing-store/deployments',
		created_at: '2020-04-08T20:32:17Z',
		updated_at: '2020-07-24T14:07:20Z',
		pushed_at: '2020-07-24T14:07:18Z',
		git_url: 'git://github.com/krittiyaclark/clothing-store.git',
		ssh_url: 'git@github.com:krittiyaclark/clothing-store.git',
		clone_url: 'https://github.com/krittiyaclark/clothing-store.git',
		svn_url: 'https://github.com/krittiyaclark/clothing-store',
		homepage: null,
		size: 1329,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 188943813,
		node_id: 'MDEwOlJlcG9zaXRvcnkxODg5NDM4MTM=',
		name: 'conntect-four-JS',
		full_name: 'krittiyaclark/conntect-four-JS',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/conntect-four-JS',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/conntect-four-JS',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/conntect-four-JS/deployments',
		created_at: '2019-05-28T03:00:56Z',
		updated_at: '2019-05-28T03:53:54Z',
		pushed_at: '2019-05-28T03:53:52Z',
		git_url: 'git://github.com/krittiyaclark/conntect-four-JS.git',
		ssh_url: 'git@github.com:krittiyaclark/conntect-four-JS.git',
		clone_url: 'https://github.com/krittiyaclark/conntect-four-JS.git',
		svn_url: 'https://github.com/krittiyaclark/conntect-four-JS',
		homepage: null,
		size: 5,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 131905841,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzE5MDU4NDE=',
		name: 'course-collaboration-travel-plans',
		full_name: 'krittiyaclark/course-collaboration-travel-plans',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/course-collaboration-travel-plans',
		description: null,
		fork: true,
		url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/course-collaboration-travel-plans/deployments',
		created_at: '2018-05-02T21:05:36Z',
		updated_at: '2018-05-02T21:05:38Z',
		pushed_at: '2018-05-02T20:56:53Z',
		git_url:
			'git://github.com/krittiyaclark/course-collaboration-travel-plans.git',
		ssh_url:
			'git@github.com:krittiyaclark/course-collaboration-travel-plans.git',
		clone_url:
			'https://github.com/krittiyaclark/course-collaboration-travel-plans.git',
		svn_url:
			'https://github.com/krittiyaclark/course-collaboration-travel-plans',
		homepage: null,
		size: 3,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'CSS',
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 232613836,
		node_id: 'MDEwOlJlcG9zaXRvcnkyMzI2MTM4MzY=',
		name: 'crown-clothing',
		full_name: 'krittiyaclark/crown-clothing',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/crown-clothing',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/crown-clothing',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/crown-clothing/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/crown-clothing/deployments',
		created_at: '2020-01-08T17:01:50Z',
		updated_at: '2020-03-02T17:25:52Z',
		pushed_at: '2020-07-19T06:15:44Z',
		git_url: 'git://github.com/krittiyaclark/crown-clothing.git',
		ssh_url: 'git@github.com:krittiyaclark/crown-clothing.git',
		clone_url: 'https://github.com/krittiyaclark/crown-clothing.git',
		svn_url: 'https://github.com/krittiyaclark/crown-clothing',
		homepage: null,
		size: 53381,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 2,
		license: null,
		forks: 0,
		open_issues: 2,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 142482753,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNDI0ODI3NTM=',
		name: 'css',
		full_name: 'krittiyaclark/css',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/css',
		description: 'A mostly reasonable approach to CSS and Sass.',
		fork: true,
		url: 'https://api.github.com/repos/krittiyaclark/css',
		forks_url: 'https://api.github.com/repos/krittiyaclark/css/forks',
		keys_url: 'https://api.github.com/repos/krittiyaclark/css/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/css/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/css/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/css/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/css/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/css/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/css/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/css/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/css/tags',
		blobs_url: 'https://api.github.com/repos/krittiyaclark/css/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/css/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/css/git/refs{/sha}',
		trees_url: 'https://api.github.com/repos/krittiyaclark/css/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/css/statuses/{sha}',
		languages_url: 'https://api.github.com/repos/krittiyaclark/css/languages',
		stargazers_url: 'https://api.github.com/repos/krittiyaclark/css/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/css/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/css/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/css/subscription',
		commits_url: 'https://api.github.com/repos/krittiyaclark/css/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/css/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/css/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/css/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/css/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/css/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/css/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/css/{archive_format}{/ref}',
		downloads_url: 'https://api.github.com/repos/krittiyaclark/css/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/css/issues{/number}',
		pulls_url: 'https://api.github.com/repos/krittiyaclark/css/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/css/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/css/notifications{?since,all,participating}',
		labels_url: 'https://api.github.com/repos/krittiyaclark/css/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/css/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/css/deployments',
		created_at: '2018-07-26T19:04:16Z',
		updated_at: '2018-07-26T19:04:17Z',
		pushed_at: '2018-07-23T16:24:23Z',
		git_url: 'git://github.com/krittiyaclark/css.git',
		ssh_url: 'git@github.com:krittiyaclark/css.git',
		clone_url: 'https://github.com/krittiyaclark/css.git',
		svn_url: 'https://github.com/krittiyaclark/css',
		homepage: null,
		size: 54,
		stargazers_count: 0,
		watchers_count: 0,
		language: null,
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: false,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: {
			key: 'mit',
			name: 'MIT License',
			spdx_id: 'MIT',
			url: 'https://api.github.com/licenses/mit',
			node_id: 'MDc6TGljZW5zZTEz',
		},
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 210477329,
		node_id: 'MDEwOlJlcG9zaXRvcnkyMTA0NzczMjk=',
		name: 'customers-angular',
		full_name: 'krittiyaclark/customers-angular',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/customers-angular',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/customers-angular',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/customers-angular/deployments',
		created_at: '2019-09-24T00:32:18Z',
		updated_at: '2019-09-24T00:39:17Z',
		pushed_at: '2020-07-18T08:44:27Z',
		git_url: 'git://github.com/krittiyaclark/customers-angular.git',
		ssh_url: 'git@github.com:krittiyaclark/customers-angular.git',
		clone_url: 'https://github.com/krittiyaclark/customers-angular.git',
		svn_url: 'https://github.com/krittiyaclark/customers-angular',
		homepage: null,
		size: 885,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 6,
		license: null,
		forks: 0,
		open_issues: 6,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 278226654,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNzgyMjY2NTQ=',
		name: 'event-react',
		full_name: 'krittiyaclark/event-react',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/event-react',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/event-react',
		forks_url: 'https://api.github.com/repos/krittiyaclark/event-react/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/event-react/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/event-react/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/event-react/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/event-react/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/event-react/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/event-react/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/event-react/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/event-react/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/event-react/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/event-react/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/event-react/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/event-react/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/event-react/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/event-react/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/event-react/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/event-react/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/event-react/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/event-react/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/event-react/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/event-react/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/event-react/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/event-react/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/event-react/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/event-react/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/event-react/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/event-react/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/event-react/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/event-react/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/event-react/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/event-react/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/event-react/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/event-react/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/event-react/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/event-react/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/event-react/deployments',
		created_at: '2020-07-09T00:54:33Z',
		updated_at: '2020-07-13T15:27:00Z',
		pushed_at: '2020-07-13T15:26:57Z',
		git_url: 'git://github.com/krittiyaclark/event-react.git',
		ssh_url: 'git@github.com:krittiyaclark/event-react.git',
		clone_url: 'https://github.com/krittiyaclark/event-react.git',
		svn_url: 'https://github.com/krittiyaclark/event-react',
		homepage: null,
		size: 1623,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 83846951,
		node_id: 'MDEwOlJlcG9zaXRvcnk4Mzg0Njk1MQ==',
		name: 'FBBot',
		full_name: 'krittiyaclark/FBBot',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/FBBot',
		description: 'FB ChatBot',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/FBBot',
		forks_url: 'https://api.github.com/repos/krittiyaclark/FBBot/forks',
		keys_url: 'https://api.github.com/repos/krittiyaclark/FBBot/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/FBBot/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/FBBot/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/FBBot/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/FBBot/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/statuses/{sha}',
		languages_url: 'https://api.github.com/repos/krittiyaclark/FBBot/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/FBBot/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/{archive_format}{/ref}',
		downloads_url: 'https://api.github.com/repos/krittiyaclark/FBBot/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/FBBot/deployments',
		created_at: '2017-03-03T22:24:34Z',
		updated_at: '2017-06-18T03:46:37Z',
		pushed_at: '2017-03-05T04:16:23Z',
		git_url: 'git://github.com/krittiyaclark/FBBot.git',
		ssh_url: 'git@github.com:krittiyaclark/FBBot.git',
		clone_url: 'https://github.com/krittiyaclark/FBBot.git',
		svn_url: 'https://github.com/krittiyaclark/FBBot',
		homepage: null,
		size: 1800,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 143950394,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNDM5NTAzOTQ=',
		name: 'flex-layout',
		full_name: 'krittiyaclark/flex-layout',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/flex-layout',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/flex-layout',
		forks_url: 'https://api.github.com/repos/krittiyaclark/flex-layout/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/flex-layout/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/flex-layout/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/flex-layout/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/flex-layout/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/flex-layout/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/flex-layout/deployments',
		created_at: '2018-08-08T02:26:18Z',
		updated_at: '2018-08-08T14:45:44Z',
		pushed_at: '2018-08-08T14:45:43Z',
		git_url: 'git://github.com/krittiyaclark/flex-layout.git',
		ssh_url: 'git@github.com:krittiyaclark/flex-layout.git',
		clone_url: 'https://github.com/krittiyaclark/flex-layout.git',
		svn_url: 'https://github.com/krittiyaclark/flex-layout',
		homepage: null,
		size: 1920,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'CSS',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 99537612,
		node_id: 'MDEwOlJlcG9zaXRvcnk5OTUzNzYxMg==',
		name: 'flexboxfroggy',
		full_name: 'krittiyaclark/flexboxfroggy',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/flexboxfroggy',
		description: 'A game for learning CSS flexbox',
		fork: true,
		url: 'https://api.github.com/repos/krittiyaclark/flexboxfroggy',
		forks_url: 'https://api.github.com/repos/krittiyaclark/flexboxfroggy/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/flexboxfroggy/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/flexboxfroggy/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/flexboxfroggy/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/flexboxfroggy/deployments',
		created_at: '2017-08-07T04:46:55Z',
		updated_at: '2017-08-07T04:46:56Z',
		pushed_at: '2017-07-31T02:03:12Z',
		git_url: 'git://github.com/krittiyaclark/flexboxfroggy.git',
		ssh_url: 'git@github.com:krittiyaclark/flexboxfroggy.git',
		clone_url: 'https://github.com/krittiyaclark/flexboxfroggy.git',
		svn_url: 'https://github.com/krittiyaclark/flexboxfroggy',
		homepage: 'http://flexboxfroggy.com',
		size: 1520,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: {
			key: 'mit',
			name: 'MIT License',
			spdx_id: 'MIT',
			url: 'https://api.github.com/licenses/mit',
			node_id: 'MDc6TGljZW5zZTEz',
		},
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'gh-pages',
	},
	{
		id: 259132871,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNTkxMzI4NzE=',
		name: 'forkify',
		full_name: 'krittiyaclark/forkify',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/forkify',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/forkify',
		forks_url: 'https://api.github.com/repos/krittiyaclark/forkify/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/forkify/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/forkify/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/forkify/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/forkify/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/forkify/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/forkify/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/forkify/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/forkify/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/forkify/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/forkify/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/forkify/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/forkify/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/forkify/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/forkify/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/forkify/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/forkify/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/forkify/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/forkify/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/forkify/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/forkify/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/forkify/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/forkify/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/forkify/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/forkify/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/forkify/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/forkify/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/forkify/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/forkify/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/forkify/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/forkify/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/forkify/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/forkify/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/forkify/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/forkify/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/forkify/deployments',
		created_at: '2020-04-26T21:04:24Z',
		updated_at: '2020-06-09T17:05:57Z',
		pushed_at: '2020-04-29T00:50:02Z',
		git_url: 'git://github.com/krittiyaclark/forkify.git',
		ssh_url: 'git@github.com:krittiyaclark/forkify.git',
		clone_url: 'https://github.com/krittiyaclark/forkify.git',
		svn_url: 'https://github.com/krittiyaclark/forkify',
		homepage: null,
		size: 11813,
		stargazers_count: 1,
		watchers_count: 1,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 1,
		default_branch: 'master',
	},
	{
		id: 130598487,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzA1OTg0ODc=',
		name: 'FreeCodeCamp',
		full_name: 'krittiyaclark/FreeCodeCamp',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/FreeCodeCamp',
		description: 'FreeCodeCamp Front-End Web Development Projects',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/FreeCodeCamp',
		forks_url: 'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp/deployments',
		created_at: '2018-04-22T19:00:52Z',
		updated_at: '2018-04-23T02:07:44Z',
		pushed_at: '2018-04-23T02:07:43Z',
		git_url: 'git://github.com/krittiyaclark/FreeCodeCamp.git',
		ssh_url: 'git@github.com:krittiyaclark/FreeCodeCamp.git',
		clone_url: 'https://github.com/krittiyaclark/FreeCodeCamp.git',
		svn_url: 'https://github.com/krittiyaclark/FreeCodeCamp',
		homepage: null,
		size: 3,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 102540052,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMDI1NDAwNTI=',
		name: 'FreeCodeCamp-CalculatorApp',
		full_name: 'krittiyaclark/FreeCodeCamp-CalculatorApp',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/FreeCodeCamp-CalculatorApp',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/FreeCodeCamp-CalculatorApp/deployments',
		created_at: '2017-09-05T23:37:39Z',
		updated_at: '2019-02-03T19:50:54Z',
		pushed_at: '2019-02-03T19:50:52Z',
		git_url: 'git://github.com/krittiyaclark/FreeCodeCamp-CalculatorApp.git',
		ssh_url: 'git@github.com:krittiyaclark/FreeCodeCamp-CalculatorApp.git',
		clone_url:
			'https://github.com/krittiyaclark/FreeCodeCamp-CalculatorApp.git',
		svn_url: 'https://github.com/krittiyaclark/FreeCodeCamp-CalculatorApp',
		homepage: null,
		size: 9754,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 1,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 1,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 282723514,
		node_id: 'MDEwOlJlcG9zaXRvcnkyODI3MjM1MTQ=',
		name: 'gitHub-Search-User-React',
		full_name: 'krittiyaclark/gitHub-Search-User-React',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/gitHub-Search-User-React',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/gitHub-Search-User-React/deployments',
		created_at: '2020-07-26T19:58:38Z',
		updated_at: '2020-07-28T12:40:05Z',
		pushed_at: '2020-07-28T12:40:02Z',
		git_url: 'git://github.com/krittiyaclark/gitHub-Search-User-React.git',
		ssh_url: 'git@github.com:krittiyaclark/gitHub-Search-User-React.git',
		clone_url: 'https://github.com/krittiyaclark/gitHub-Search-User-React.git',
		svn_url: 'https://github.com/krittiyaclark/gitHub-Search-User-React',
		homepage: null,
		size: 542,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 128825421,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMjg4MjU0MjE=',
		name: 'Intro-to-Computer-Science',
		full_name: 'krittiyaclark/Intro-to-Computer-Science',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Intro-to-Computer-Science',
		description: 'Intro to computer science using Python',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Intro-to-Computer-Science/deployments',
		created_at: '2018-04-09T19:48:24Z',
		updated_at: '2018-04-12T21:28:53Z',
		pushed_at: '2018-04-12T21:28:52Z',
		git_url: 'git://github.com/krittiyaclark/Intro-to-Computer-Science.git',
		ssh_url: 'git@github.com:krittiyaclark/Intro-to-Computer-Science.git',
		clone_url: 'https://github.com/krittiyaclark/Intro-to-Computer-Science.git',
		svn_url: 'https://github.com/krittiyaclark/Intro-to-Computer-Science',
		homepage: '',
		size: 8,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'Python',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 259826453,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNTk4MjY0NTM=',
		name: 'javascript-projects-for-beginners',
		full_name: 'krittiyaclark/javascript-projects-for-beginners',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/javascript-projects-for-beginners',
		description:
			'Repository for all (future) 100+ JavaScript projects for beginners created on JSBeginners.com.',
		fork: true,
		url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/javascript-projects-for-beginners/deployments',
		created_at: '2020-04-29T04:46:07Z',
		updated_at: '2020-04-29T04:46:09Z',
		pushed_at: '2019-10-17T17:29:22Z',
		git_url:
			'git://github.com/krittiyaclark/javascript-projects-for-beginners.git',
		ssh_url:
			'git@github.com:krittiyaclark/javascript-projects-for-beginners.git',
		clone_url:
			'https://github.com/krittiyaclark/javascript-projects-for-beginners.git',
		svn_url:
			'https://github.com/krittiyaclark/javascript-projects-for-beginners',
		homepage: 'https://jsbeginners.com/',
		size: 5623,
		stargazers_count: 0,
		watchers_count: 0,
		language: null,
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 92326258,
		node_id: 'MDEwOlJlcG9zaXRvcnk5MjMyNjI1OA==',
		name: 'JSON-Hostpitality',
		full_name: 'krittiyaclark/JSON-Hostpitality',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/JSON-Hostpitality',
		description: 'JSON/AJAX display room prices/detail/picture each room.',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/JSON-Hostpitality/deployments',
		created_at: '2017-05-24T18:55:52Z',
		updated_at: '2019-05-07T18:00:10Z',
		pushed_at: '2017-05-24T19:05:25Z',
		git_url: 'git://github.com/krittiyaclark/JSON-Hostpitality.git',
		ssh_url: 'git@github.com:krittiyaclark/JSON-Hostpitality.git',
		clone_url: 'https://github.com/krittiyaclark/JSON-Hostpitality.git',
		svn_url: 'https://github.com/krittiyaclark/JSON-Hostpitality',
		homepage: null,
		size: 1798,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 238351399,
		node_id: 'MDEwOlJlcG9zaXRvcnkyMzgzNTEzOTk=',
		name: 'JS_Fun_Practice',
		full_name: 'krittiyaclark/JS_Fun_Practice',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/JS_Fun_Practice',
		description:
			'A list of small & fun functional programming exercises in JavaScript',
		fork: true,
		url: 'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/JS_Fun_Practice/deployments',
		created_at: '2020-02-05T02:27:02Z',
		updated_at: '2020-02-05T02:27:04Z',
		pushed_at: '2020-01-29T20:00:04Z',
		git_url: 'git://github.com/krittiyaclark/JS_Fun_Practice.git',
		ssh_url: 'git@github.com:krittiyaclark/JS_Fun_Practice.git',
		clone_url: 'https://github.com/krittiyaclark/JS_Fun_Practice.git',
		svn_url: 'https://github.com/krittiyaclark/JS_Fun_Practice',
		homepage: '',
		size: 244,
		stargazers_count: 0,
		watchers_count: 0,
		language: null,
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: {
			key: 'mit',
			name: 'MIT License',
			spdx_id: 'MIT',
			url: 'https://api.github.com/licenses/mit',
			node_id: 'MDc6TGljZW5zZTEz',
		},
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 182524318,
		node_id: 'MDEwOlJlcG9zaXRvcnkxODI1MjQzMTg=',
		name: 'junior-showcase-with-React',
		full_name: 'krittiyaclark/junior-showcase-with-React',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/junior-showcase-with-React',
		description:
			'The Junior Showcase website is the website for junior web developers to showcase their awesome projects.',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/junior-showcase-with-React/deployments',
		created_at: '2019-04-21T11:26:10Z',
		updated_at: '2019-06-24T21:22:29Z',
		pushed_at: '2020-07-17T00:54:08Z',
		git_url: 'git://github.com/krittiyaclark/junior-showcase-with-React.git',
		ssh_url: 'git@github.com:krittiyaclark/junior-showcase-with-React.git',
		clone_url:
			'https://github.com/krittiyaclark/junior-showcase-with-React.git',
		svn_url: 'https://github.com/krittiyaclark/junior-showcase-with-React',
		homepage: 'https://wippo-c6ee3.firebaseapp.com/',
		size: 9791,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 12,
		license: null,
		forks: 0,
		open_issues: 12,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 247522808,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNDc1MjI4MDg=',
		name: 'kritttiyaclark-portfolio',
		full_name: 'krittiyaclark/kritttiyaclark-portfolio',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/kritttiyaclark-portfolio',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/kritttiyaclark-portfolio/deployments',
		created_at: '2020-03-15T18:06:51Z',
		updated_at: '2020-07-24T14:36:21Z',
		pushed_at: '2020-07-24T14:36:19Z',
		git_url: 'git://github.com/krittiyaclark/kritttiyaclark-portfolio.git',
		ssh_url: 'git@github.com:krittiyaclark/kritttiyaclark-portfolio.git',
		clone_url: 'https://github.com/krittiyaclark/kritttiyaclark-portfolio.git',
		svn_url: 'https://github.com/krittiyaclark/kritttiyaclark-portfolio',
		homepage: null,
		size: 55006,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 2,
		license: null,
		forks: 0,
		open_issues: 2,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 94662709,
		node_id: 'MDEwOlJlcG9zaXRvcnk5NDY2MjcwOQ==',
		name: 'learn-node.js',
		full_name: 'krittiyaclark/learn-node.js',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/learn-node.js',
		description: 'Node.js exercises from w3 school.',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/learn-node.js',
		forks_url: 'https://api.github.com/repos/krittiyaclark/learn-node.js/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/learn-node.js/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/learn-node.js/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/learn-node.js/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/learn-node.js/deployments',
		created_at: '2017-06-18T03:28:08Z',
		updated_at: '2017-06-18T03:50:51Z',
		pushed_at: '2017-06-19T19:32:52Z',
		git_url: 'git://github.com/krittiyaclark/learn-node.js.git',
		ssh_url: 'git@github.com:krittiyaclark/learn-node.js.git',
		clone_url: 'https://github.com/krittiyaclark/learn-node.js.git',
		svn_url: 'https://github.com/krittiyaclark/learn-node.js',
		homepage: null,
		size: 5,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 95398858,
		node_id: 'MDEwOlJlcG9zaXRvcnk5NTM5ODg1OA==',
		name: 'Local-Weather-App-FCC',
		full_name: 'krittiyaclark/Local-Weather-App-FCC',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Local-Weather-App-FCC',
		description:
			"FreeCodeCamp's assignment build Local Weather App use JSON with Openweather API.",
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Local-Weather-App-FCC/deployments',
		created_at: '2017-06-26T02:04:08Z',
		updated_at: '2017-06-26T02:05:32Z',
		pushed_at: '2017-07-05T20:31:52Z',
		git_url: 'git://github.com/krittiyaclark/Local-Weather-App-FCC.git',
		ssh_url: 'git@github.com:krittiyaclark/Local-Weather-App-FCC.git',
		clone_url: 'https://github.com/krittiyaclark/Local-Weather-App-FCC.git',
		svn_url: 'https://github.com/krittiyaclark/Local-Weather-App-FCC',
		homepage: null,
		size: 5,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 129549616,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMjk1NDk2MTY=',
		name: 'MIT_Introduction_to_Computer_Science',
		full_name: 'krittiyaclark/MIT_Introduction_to_Computer_Science',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/MIT_Introduction_to_Computer_Science',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/MIT_Introduction_to_Computer_Science/deployments',
		created_at: '2018-04-14T19:50:59Z',
		updated_at: '2018-04-22T03:50:45Z',
		pushed_at: '2018-04-22T03:50:44Z',
		git_url:
			'git://github.com/krittiyaclark/MIT_Introduction_to_Computer_Science.git',
		ssh_url:
			'git@github.com:krittiyaclark/MIT_Introduction_to_Computer_Science.git',
		clone_url:
			'https://github.com/krittiyaclark/MIT_Introduction_to_Computer_Science.git',
		svn_url:
			'https://github.com/krittiyaclark/MIT_Introduction_to_Computer_Science',
		homepage: null,
		size: 2241,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'Python',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 98327100,
		node_id: 'MDEwOlJlcG9zaXRvcnk5ODMyNzEwMA==',
		name: 'Momentumdash',
		full_name: 'krittiyaclark/Momentumdash',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Momentumdash',
		description:
			'Chingu Voyage Build-To-Learn Project build Chrome extension, Momentumdash.',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Momentumdash',
		forks_url: 'https://api.github.com/repos/krittiyaclark/Momentumdash/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/Momentumdash/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/Momentumdash/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/Momentumdash/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Momentumdash/deployments',
		created_at: '2017-07-25T16:22:34Z',
		updated_at: '2020-02-29T06:33:30Z',
		pushed_at: '2018-10-28T21:41:10Z',
		git_url: 'git://github.com/krittiyaclark/Momentumdash.git',
		ssh_url: 'git@github.com:krittiyaclark/Momentumdash.git',
		clone_url: 'https://github.com/krittiyaclark/Momentumdash.git',
		svn_url: 'https://github.com/krittiyaclark/Momentumdash',
		homepage: null,
		size: 3474,
		stargazers_count: 1,
		watchers_count: 1,
		language: 'CSS',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 1,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 1,
		open_issues: 0,
		watchers: 1,
		default_branch: 'master',
	},
	{
		id: 112255634,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMTIyNTU2MzQ=',
		name: 'Multiple-purposes-template---Simple',
		full_name: 'krittiyaclark/Multiple-purposes-template---Simple',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/Multiple-purposes-template---Simple',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Multiple-purposes-template---Simple/deployments',
		created_at: '2017-11-27T22:23:15Z',
		updated_at: '2017-11-27T22:55:22Z',
		pushed_at: '2017-11-27T22:55:20Z',
		git_url:
			'git://github.com/krittiyaclark/Multiple-purposes-template---Simple.git',
		ssh_url:
			'git@github.com:krittiyaclark/Multiple-purposes-template---Simple.git',
		clone_url:
			'https://github.com/krittiyaclark/Multiple-purposes-template---Simple.git',
		svn_url:
			'https://github.com/krittiyaclark/Multiple-purposes-template---Simple',
		homepage: null,
		size: 19886,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 164941253,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNjQ5NDEyNTM=',
		name: 'my-portfolio-react',
		full_name: 'krittiyaclark/my-portfolio-react',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/my-portfolio-react',
		description: 'The personal portfolio built with React.',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/my-portfolio-react',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/my-portfolio-react/deployments',
		created_at: '2019-01-09T21:31:39Z',
		updated_at: '2019-06-25T15:48:55Z',
		pushed_at: '2020-06-06T13:24:33Z',
		git_url: 'git://github.com/krittiyaclark/my-portfolio-react.git',
		ssh_url: 'git@github.com:krittiyaclark/my-portfolio-react.git',
		clone_url: 'https://github.com/krittiyaclark/my-portfolio-react.git',
		svn_url: 'https://github.com/krittiyaclark/my-portfolio-react',
		homepage: '',
		size: 33766,
		stargazers_count: 1,
		watchers_count: 1,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 12,
		license: null,
		forks: 0,
		open_issues: 12,
		watchers: 1,
		default_branch: 'master',
	},
	{
		id: 267340620,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNjczNDA2MjA=',
		name: 'note-react',
		full_name: 'krittiyaclark/note-react',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/note-react',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/note-react',
		forks_url: 'https://api.github.com/repos/krittiyaclark/note-react/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/note-react/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/note-react/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/note-react/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/note-react/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/note-react/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/note-react/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/note-react/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/note-react/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/note-react/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/note-react/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/note-react/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/note-react/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/note-react/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/note-react/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/note-react/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/note-react/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/note-react/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/note-react/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/note-react/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/note-react/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/note-react/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/note-react/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/note-react/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/note-react/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/note-react/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/note-react/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/note-react/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/note-react/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/note-react/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/note-react/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/note-react/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/note-react/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/note-react/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/note-react/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/note-react/deployments',
		created_at: '2020-05-27T14:25:12Z',
		updated_at: '2020-05-30T18:06:32Z',
		pushed_at: '2020-06-08T08:47:46Z',
		git_url: 'git://github.com/krittiyaclark/note-react.git',
		ssh_url: 'git@github.com:krittiyaclark/note-react.git',
		clone_url: 'https://github.com/krittiyaclark/note-react.git',
		svn_url: 'https://github.com/krittiyaclark/note-react',
		homepage: null,
		size: 630,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 87375032,
		node_id: 'MDEwOlJlcG9zaXRvcnk4NzM3NTAzMg==',
		name: 'One-Page-Portfolio',
		full_name: 'krittiyaclark/One-Page-Portfolio',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/One-Page-Portfolio',
		description: 'FCC project. Build a personal portfolio with Bootstrap.',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/One-Page-Portfolio/deployments',
		created_at: '2017-04-06T02:01:12Z',
		updated_at: '2017-06-18T04:03:11Z',
		pushed_at: '2017-06-18T04:01:07Z',
		git_url: 'git://github.com/krittiyaclark/One-Page-Portfolio.git',
		ssh_url: 'git@github.com:krittiyaclark/One-Page-Portfolio.git',
		clone_url: 'https://github.com/krittiyaclark/One-Page-Portfolio.git',
		svn_url: 'https://github.com/krittiyaclark/One-Page-Portfolio',
		homepage: '',
		size: 938,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'CSS',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 274009060,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNzQwMDkwNjA=',
		name: 'Photogram-React',
		full_name: 'krittiyaclark/Photogram-React',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Photogram-React',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Photogram-React',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/Photogram-React/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Photogram-React/deployments',
		created_at: '2020-06-22T00:59:50Z',
		updated_at: '2020-06-23T19:54:43Z',
		pushed_at: '2020-06-27T02:00:04Z',
		git_url: 'git://github.com/krittiyaclark/Photogram-React.git',
		ssh_url: 'git@github.com:krittiyaclark/Photogram-React.git',
		clone_url: 'https://github.com/krittiyaclark/Photogram-React.git',
		svn_url: 'https://github.com/krittiyaclark/Photogram-React',
		homepage: null,
		size: 422,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 103839562,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMDM4Mzk1NjI=',
		name: 'Pomodoro-Clock',
		full_name: 'krittiyaclark/Pomodoro-Clock',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Pomodoro-Clock',
		description:
			'Free Code Camp Front End Web Development Project Build a Pomodoro Clock  ',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Pomodoro-Clock/deployments',
		created_at: '2017-09-17T15:28:20Z',
		updated_at: '2017-09-17T21:16:58Z',
		pushed_at: '2017-09-22T16:40:44Z',
		git_url: 'git://github.com/krittiyaclark/Pomodoro-Clock.git',
		ssh_url: 'git@github.com:krittiyaclark/Pomodoro-Clock.git',
		clone_url: 'https://github.com/krittiyaclark/Pomodoro-Clock.git',
		svn_url: 'https://github.com/krittiyaclark/Pomodoro-Clock',
		homepage: null,
		size: 82,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 167360222,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNjczNjAyMjI=',
		name: 'PomodoroClock',
		full_name: 'krittiyaclark/PomodoroClock',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/PomodoroClock',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/PomodoroClock',
		forks_url: 'https://api.github.com/repos/krittiyaclark/PomodoroClock/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/PomodoroClock/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/PomodoroClock/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/PomodoroClock/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/PomodoroClock/deployments',
		created_at: '2019-01-24T11:57:04Z',
		updated_at: '2019-01-24T12:40:36Z',
		pushed_at: '2019-01-24T12:40:34Z',
		git_url: 'git://github.com/krittiyaclark/PomodoroClock.git',
		ssh_url: 'git@github.com:krittiyaclark/PomodoroClock.git',
		clone_url: 'https://github.com/krittiyaclark/PomodoroClock.git',
		svn_url: 'https://github.com/krittiyaclark/PomodoroClock',
		homepage: null,
		size: 2,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 132689813,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzI2ODk4MTM=',
		name: 'project-starter',
		full_name: 'krittiyaclark/project-starter',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/project-starter',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/project-starter',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/project-starter/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/project-starter/deployments',
		created_at: '2018-05-09T02:19:21Z',
		updated_at: '2018-05-09T20:57:22Z',
		pushed_at: '2018-05-09T20:57:22Z',
		git_url: 'git://github.com/krittiyaclark/project-starter.git',
		ssh_url: 'git@github.com:krittiyaclark/project-starter.git',
		clone_url: 'https://github.com/krittiyaclark/project-starter.git',
		svn_url: 'https://github.com/krittiyaclark/project-starter',
		homepage: null,
		size: 4,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 127194207,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMjcxOTQyMDc=',
		name: 'Python-deck-of-card-project',
		full_name: 'krittiyaclark/Python-deck-of-card-project',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Python-deck-of-card-project',
		description:
			'Python Object Oriented Programming build a Python deck of card project',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck-of-card-project/deployments',
		created_at: '2018-03-28T20:23:42Z',
		updated_at: '2018-03-28T21:30:28Z',
		pushed_at: '2018-03-28T21:30:27Z',
		git_url: 'git://github.com/krittiyaclark/Python-deck-of-card-project.git',
		ssh_url: 'git@github.com:krittiyaclark/Python-deck-of-card-project.git',
		clone_url:
			'https://github.com/krittiyaclark/Python-deck-of-card-project.git',
		svn_url: 'https://github.com/krittiyaclark/Python-deck-of-card-project',
		homepage: null,
		size: 1,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'Python',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 127192013,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMjcxOTIwMTM=',
		name: 'Python-deck_of_card-project',
		full_name: 'krittiyaclark/Python-deck_of_card-project',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Python-deck_of_card-project',
		description: 'Object Oriented Programming build a deck of card application',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Python-deck_of_card-project/deployments',
		created_at: '2018-03-28T20:02:49Z',
		updated_at: '2018-03-28T20:18:01Z',
		pushed_at: '2018-03-28T20:18:00Z',
		git_url: 'git://github.com/krittiyaclark/Python-deck_of_card-project.git',
		ssh_url: 'git@github.com:krittiyaclark/Python-deck_of_card-project.git',
		clone_url:
			'https://github.com/krittiyaclark/Python-deck_of_card-project.git',
		svn_url: 'https://github.com/krittiyaclark/Python-deck_of_card-project',
		homepage: '',
		size: 1,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'Python',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 95192043,
		node_id: 'MDEwOlJlcG9zaXRvcnk5NTE5MjA0Mw==',
		name: 'Random-Quote-Machine',
		full_name: 'krittiyaclark/Random-Quote-Machine',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Random-Quote-Machine',
		description:
			'FCC assignment, build Random Quote Machine by using JSON, AJAX and API. ',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Random-Quote-Machine/deployments',
		created_at: '2017-06-23T06:53:29Z',
		updated_at: '2017-06-23T07:40:31Z',
		pushed_at: '2017-06-23T19:33:52Z',
		git_url: 'git://github.com/krittiyaclark/Random-Quote-Machine.git',
		ssh_url: 'git@github.com:krittiyaclark/Random-Quote-Machine.git',
		clone_url: 'https://github.com/krittiyaclark/Random-Quote-Machine.git',
		svn_url: 'https://github.com/krittiyaclark/Random-Quote-Machine',
		homepage: '',
		size: 3,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 155486137,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNTU0ODYxMzc=',
		name: 'React-Contacts',
		full_name: 'krittiyaclark/React-Contacts',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/React-Contacts',
		description: 'Contact list application built with React.',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/React-Contacts',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/React-Contacts/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/React-Contacts/deployments',
		created_at: '2018-10-31T02:27:11Z',
		updated_at: '2018-11-25T16:36:28Z',
		pushed_at: '2018-11-25T16:36:27Z',
		git_url: 'git://github.com/krittiyaclark/React-Contacts.git',
		ssh_url: 'git@github.com:krittiyaclark/React-Contacts.git',
		clone_url: 'https://github.com/krittiyaclark/React-Contacts.git',
		svn_url: 'https://github.com/krittiyaclark/React-Contacts',
		homepage: '',
		size: 633,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 105176674,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMDUxNzY2NzQ=',
		name: 'React-Multiple-Apps',
		full_name: 'krittiyaclark/React-Multiple-Apps',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/React-Multiple-Apps',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/React-Multiple-Apps/deployments',
		created_at: '2017-09-28T17:09:40Z',
		updated_at: '2017-09-28T17:17:44Z',
		pushed_at: '2017-09-29T21:30:19Z',
		git_url: 'git://github.com/krittiyaclark/React-Multiple-Apps.git',
		ssh_url: 'git@github.com:krittiyaclark/React-Multiple-Apps.git',
		clone_url: 'https://github.com/krittiyaclark/React-Multiple-Apps.git',
		svn_url: 'https://github.com/krittiyaclark/React-Multiple-Apps',
		homepage: null,
		size: 7685,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 104014922,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMDQwMTQ5MjI=',
		name: 'React-Native-Appointment',
		full_name: 'krittiyaclark/React-Native-Appointment',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/React-Native-Appointment',
		description: 'Local Doctor listing',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/React-Native-Appointment',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/React-Native-Appointment/deployments',
		created_at: '2017-09-19T02:18:36Z',
		updated_at: '2018-08-20T04:29:09Z',
		pushed_at: '2017-10-26T22:16:28Z',
		git_url: 'git://github.com/krittiyaclark/React-Native-Appointment.git',
		ssh_url: 'git@github.com:krittiyaclark/React-Native-Appointment.git',
		clone_url: 'https://github.com/krittiyaclark/React-Native-Appointment.git',
		svn_url: 'https://github.com/krittiyaclark/React-Native-Appointment',
		homepage: '',
		size: 133,
		stargazers_count: 1,
		watchers_count: 1,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 1,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 1,
		open_issues: 0,
		watchers: 1,
		default_branch: 'master',
	},
	{
		id: 101224662,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMDEyMjQ2NjI=',
		name: 'react-ssr-boilerplate',
		full_name: 'krittiyaclark/react-ssr-boilerplate',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/react-ssr-boilerplate',
		description:
			'A boilerplate for server-side rendered React Applications with React Router 4.',
		fork: true,
		url: 'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/react-ssr-boilerplate/deployments',
		created_at: '2017-08-23T21:01:29Z',
		updated_at: '2017-08-23T21:01:30Z',
		pushed_at: '2017-06-25T19:43:40Z',
		git_url: 'git://github.com/krittiyaclark/react-ssr-boilerplate.git',
		ssh_url: 'git@github.com:krittiyaclark/react-ssr-boilerplate.git',
		clone_url: 'https://github.com/krittiyaclark/react-ssr-boilerplate.git',
		svn_url: 'https://github.com/krittiyaclark/react-ssr-boilerplate',
		homepage: '',
		size: 2188,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 100417703,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMDA0MTc3MDM=',
		name: 'react-todo',
		full_name: 'krittiyaclark/react-todo',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/react-todo',
		description: 'Build a todo list using React, Babel and Webpack.',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/react-todo',
		forks_url: 'https://api.github.com/repos/krittiyaclark/react-todo/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/react-todo/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/react-todo/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/react-todo/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/react-todo/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/react-todo/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/react-todo/deployments',
		created_at: '2017-08-15T20:41:28Z',
		updated_at: '2017-08-21T21:24:53Z',
		pushed_at: '2017-08-21T06:42:08Z',
		git_url: 'git://github.com/krittiyaclark/react-todo.git',
		ssh_url: 'git@github.com:krittiyaclark/react-todo.git',
		clone_url: 'https://github.com/krittiyaclark/react-todo.git',
		svn_url: 'https://github.com/krittiyaclark/react-todo',
		homepage: '',
		size: 14330,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 104704360,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMDQ3MDQzNjA=',
		name: 'React-Youtube',
		full_name: 'krittiyaclark/React-Youtube',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/React-Youtube',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/React-Youtube',
		forks_url: 'https://api.github.com/repos/krittiyaclark/React-Youtube/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/React-Youtube/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/React-Youtube/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/React-Youtube/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/React-Youtube/deployments',
		created_at: '2017-09-25T04:48:46Z',
		updated_at: '2017-09-25T04:51:45Z',
		pushed_at: '2018-12-09T09:31:38Z',
		git_url: 'git://github.com/krittiyaclark/React-Youtube.git',
		ssh_url: 'git@github.com:krittiyaclark/React-Youtube.git',
		clone_url: 'https://github.com/krittiyaclark/React-Youtube.git',
		svn_url: 'https://github.com/krittiyaclark/React-Youtube',
		homepage: null,
		size: 51,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 1,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: {
			key: 'mit',
			name: 'MIT License',
			spdx_id: 'MIT',
			url: 'https://api.github.com/licenses/mit',
			node_id: 'MDc6TGljZW5zZTEz',
		},
		forks: 1,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 241222964,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNDEyMjI5NjQ=',
		name: 'ReactMiniProjects',
		full_name: 'krittiyaclark/ReactMiniProjects',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/ReactMiniProjects',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/ReactMiniProjects',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/ReactMiniProjects/deployments',
		created_at: '2020-02-17T22:41:09Z',
		updated_at: '2020-07-08T15:29:37Z',
		pushed_at: '2020-07-08T15:29:34Z',
		git_url: 'git://github.com/krittiyaclark/ReactMiniProjects.git',
		ssh_url: 'git@github.com:krittiyaclark/ReactMiniProjects.git',
		clone_url: 'https://github.com/krittiyaclark/ReactMiniProjects.git',
		svn_url: 'https://github.com/krittiyaclark/ReactMiniProjects',
		homepage: null,
		size: 3763,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 7,
		license: null,
		forks: 0,
		open_issues: 7,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 102269343,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMDIyNjkzNDM=',
		name: 'ReactNative-MusicAlbum',
		full_name: 'krittiyaclark/ReactNative-MusicAlbum',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/ReactNative-MusicAlbum',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/ReactNative-MusicAlbum/deployments',
		created_at: '2017-09-03T14:13:46Z',
		updated_at: '2017-09-03T19:43:04Z',
		pushed_at: '2017-09-18T20:33:34Z',
		git_url: 'git://github.com/krittiyaclark/ReactNative-MusicAlbum.git',
		ssh_url: 'git@github.com:krittiyaclark/ReactNative-MusicAlbum.git',
		clone_url: 'https://github.com/krittiyaclark/ReactNative-MusicAlbum.git',
		svn_url: 'https://github.com/krittiyaclark/ReactNative-MusicAlbum',
		homepage: null,
		size: 427,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 104941286,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMDQ5NDEyODY=',
		name: 'Redux-BookList',
		full_name: 'krittiyaclark/Redux-BookList',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Redux-BookList',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Redux-BookList',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/Redux-BookList/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Redux-BookList/deployments',
		created_at: '2017-09-26T21:49:51Z',
		updated_at: '2017-09-26T21:56:51Z',
		pushed_at: '2017-09-27T01:55:15Z',
		git_url: 'git://github.com/krittiyaclark/Redux-BookList.git',
		ssh_url: 'git@github.com:krittiyaclark/Redux-BookList.git',
		clone_url: 'https://github.com/krittiyaclark/Redux-BookList.git',
		svn_url: 'https://github.com/krittiyaclark/Redux-BookList',
		homepage: null,
		size: 59,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: {
			key: 'mit',
			name: 'MIT License',
			spdx_id: 'MIT',
			url: 'https://api.github.com/licenses/mit',
			node_id: 'MDc6TGljZW5zZTEz',
		},
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 261941501,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNjE5NDE1MDE=',
		name: 'settimeout-',
		full_name: 'krittiyaclark/settimeout-',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/settimeout-',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/settimeout-',
		forks_url: 'https://api.github.com/repos/krittiyaclark/settimeout-/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/settimeout-/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/settimeout-/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/settimeout-/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/settimeout-/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/settimeout-/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/settimeout-/deployments',
		created_at: '2020-05-07T03:35:55Z',
		updated_at: '2020-05-07T13:54:35Z',
		pushed_at: '2020-05-07T13:54:32Z',
		git_url: 'git://github.com/krittiyaclark/settimeout-.git',
		ssh_url: 'git@github.com:krittiyaclark/settimeout-.git',
		clone_url: 'https://github.com/krittiyaclark/settimeout-.git',
		svn_url: 'https://github.com/krittiyaclark/settimeout-',
		homepage: null,
		size: 1946,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'CSS',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 210882643,
		node_id: 'MDEwOlJlcG9zaXRvcnkyMTA4ODI2NDM=',
		name: 'Shopping-List-Angular',
		full_name: 'krittiyaclark/Shopping-List-Angular',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Shopping-List-Angular',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Shopping-List-Angular/deployments',
		created_at: '2019-09-25T15:45:15Z',
		updated_at: '2019-09-25T15:45:15Z',
		pushed_at: '2019-09-25T15:45:15Z',
		git_url: 'git://github.com/krittiyaclark/Shopping-List-Angular.git',
		ssh_url: 'git@github.com:krittiyaclark/Shopping-List-Angular.git',
		clone_url: 'https://github.com/krittiyaclark/Shopping-List-Angular.git',
		svn_url: 'https://github.com/krittiyaclark/Shopping-List-Angular',
		homepage: null,
		size: 0,
		stargazers_count: 0,
		watchers_count: 0,
		language: null,
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 91525224,
		node_id: 'MDEwOlJlcG9zaXRvcnk5MTUyNTIyNA==',
		name: 'Show-the-Local-Weather',
		full_name: 'krittiyaclark/Show-the-Local-Weather',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Show-the-Local-Weather',
		description: 'FCC Show the Local Weather App',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Show-the-Local-Weather/deployments',
		created_at: '2017-05-17T02:32:04Z',
		updated_at: '2017-06-18T03:53:18Z',
		pushed_at: '2017-06-18T04:09:11Z',
		git_url: 'git://github.com/krittiyaclark/Show-the-Local-Weather.git',
		ssh_url: 'git@github.com:krittiyaclark/Show-the-Local-Weather.git',
		clone_url: 'https://github.com/krittiyaclark/Show-the-Local-Weather.git',
		svn_url: 'https://github.com/krittiyaclark/Show-the-Local-Weather',
		homepage: null,
		size: 189,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'CSS',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 41220492,
		node_id: 'MDEwOlJlcG9zaXRvcnk0MTIyMDQ5Mg==',
		name: 'simplecodecasts_saas',
		full_name: 'krittiyaclark/simplecodecasts_saas',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/simplecodecasts_saas',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/simplecodecasts_saas/deployments',
		created_at: '2015-08-22T18:58:18Z',
		updated_at: '2015-08-22T19:03:57Z',
		pushed_at: '2020-02-26T14:56:23Z',
		git_url: 'git://github.com/krittiyaclark/simplecodecasts_saas.git',
		ssh_url: 'git@github.com:krittiyaclark/simplecodecasts_saas.git',
		clone_url: 'https://github.com/krittiyaclark/simplecodecasts_saas.git',
		svn_url: 'https://github.com/krittiyaclark/simplecodecasts_saas',
		homepage: null,
		size: 50,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'Ruby',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 277915425,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNzc5MTU0MjU=',
		name: 'social-network',
		full_name: 'krittiyaclark/social-network',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/social-network',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/social-network',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/social-network/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/social-network/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/social-network/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/social-network/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/social-network/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/social-network/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/social-network/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/social-network/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/social-network/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/social-network/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/social-network/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/social-network/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/social-network/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/social-network/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/social-network/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/social-network/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/social-network/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/social-network/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/social-network/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/social-network/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/social-network/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/social-network/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/social-network/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/social-network/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/social-network/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/social-network/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/social-network/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/social-network/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/social-network/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/social-network/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/social-network/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/social-network/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/social-network/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/social-network/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/social-network/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/social-network/deployments',
		created_at: '2020-07-07T20:27:53Z',
		updated_at: '2020-07-07T20:30:11Z',
		pushed_at: '2020-07-21T10:48:48Z',
		git_url: 'git://github.com/krittiyaclark/social-network.git',
		ssh_url: 'git@github.com:krittiyaclark/social-network.git',
		clone_url: 'https://github.com/krittiyaclark/social-network.git',
		svn_url: 'https://github.com/krittiyaclark/social-network',
		homepage: null,
		size: 52,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 195843805,
		node_id: 'MDEwOlJlcG9zaXRvcnkxOTU4NDM4MDU=',
		name: 'Sort-API',
		full_name: 'krittiyaclark/Sort-API',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Sort-API',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Sort-API',
		forks_url: 'https://api.github.com/repos/krittiyaclark/Sort-API/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/Sort-API/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/Sort-API/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/Sort-API/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/Sort-API/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/Sort-API/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Sort-API/deployments',
		created_at: '2019-07-08T15:50:00Z',
		updated_at: '2019-07-18T18:08:50Z',
		pushed_at: '2020-06-07T00:30:55Z',
		git_url: 'git://github.com/krittiyaclark/Sort-API.git',
		ssh_url: 'git@github.com:krittiyaclark/Sort-API.git',
		clone_url: 'https://github.com/krittiyaclark/Sort-API.git',
		svn_url: 'https://github.com/krittiyaclark/Sort-API',
		homepage: null,
		size: 1118,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 1,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 4,
		license: null,
		forks: 1,
		open_issues: 4,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 279642933,
		node_id: 'MDEwOlJlcG9zaXRvcnkyNzk2NDI5MzM=',
		name: 'tech-ecommerce-store-react',
		full_name: 'krittiyaclark/tech-ecommerce-store-react',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/tech-ecommerce-store-react',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/tech-ecommerce-store-react/deployments',
		created_at: '2020-07-14T16:52:24Z',
		updated_at: '2020-07-22T21:19:24Z',
		pushed_at: '2020-07-22T21:19:21Z',
		git_url: 'git://github.com/krittiyaclark/tech-ecommerce-store-react.git',
		ssh_url: 'git@github.com:krittiyaclark/tech-ecommerce-store-react.git',
		clone_url:
			'https://github.com/krittiyaclark/tech-ecommerce-store-react.git',
		svn_url: 'https://github.com/krittiyaclark/tech-ecommerce-store-react',
		homepage: null,
		size: 1086,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 164343331,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNjQzNDMzMzE=',
		name: 'Tic-Tac-Toe',
		full_name: 'krittiyaclark/Tic-Tac-Toe',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Tic-Tac-Toe',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe',
		forks_url: 'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Tic-Tac-Toe/deployments',
		created_at: '2019-01-06T20:35:09Z',
		updated_at: '2019-01-14T20:10:34Z',
		pushed_at: '2019-01-14T20:10:33Z',
		git_url: 'git://github.com/krittiyaclark/Tic-Tac-Toe.git',
		ssh_url: 'git@github.com:krittiyaclark/Tic-Tac-Toe.git',
		clone_url: 'https://github.com/krittiyaclark/Tic-Tac-Toe.git',
		svn_url: 'https://github.com/krittiyaclark/Tic-Tac-Toe',
		homepage: null,
		size: 1286,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 93122727,
		node_id: 'MDEwOlJlcG9zaXRvcnk5MzEyMjcyNw==',
		name: 'Todo-Lists',
		full_name: 'krittiyaclark/Todo-Lists',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Todo-Lists',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Todo-Lists',
		forks_url: 'https://api.github.com/repos/krittiyaclark/Todo-Lists/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/Todo-Lists/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/Todo-Lists/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/Todo-Lists/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/Todo-Lists/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/Todo-Lists/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Todo-Lists/deployments',
		created_at: '2017-06-02T03:21:19Z',
		updated_at: '2017-06-18T03:49:47Z',
		pushed_at: '2017-06-09T01:57:09Z',
		git_url: 'git://github.com/krittiyaclark/Todo-Lists.git',
		ssh_url: 'git@github.com:krittiyaclark/Todo-Lists.git',
		clone_url: 'https://github.com/krittiyaclark/Todo-Lists.git',
		svn_url: 'https://github.com/krittiyaclark/Todo-Lists',
		homepage: null,
		size: 6,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 180437321,
		node_id: 'MDEwOlJlcG9zaXRvcnkxODA0MzczMjE=',
		name: 'Todoapp-React',
		full_name: 'krittiyaclark/Todoapp-React',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Todoapp-React',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Todoapp-React',
		forks_url: 'https://api.github.com/repos/krittiyaclark/Todoapp-React/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/Todoapp-React/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/Todoapp-React/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/Todoapp-React/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Todoapp-React/deployments',
		created_at: '2019-04-09T19:39:01Z',
		updated_at: '2019-04-09T19:45:35Z',
		pushed_at: '2020-06-06T14:57:46Z',
		git_url: 'git://github.com/krittiyaclark/Todoapp-React.git',
		ssh_url: 'git@github.com:krittiyaclark/Todoapp-React.git',
		clone_url: 'https://github.com/krittiyaclark/Todoapp-React.git',
		svn_url: 'https://github.com/krittiyaclark/Todoapp-React',
		homepage: null,
		size: 23478,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 6,
		license: null,
		forks: 0,
		open_issues: 6,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 96590948,
		node_id: 'MDEwOlJlcG9zaXRvcnk5NjU5MDk0OA==',
		name: 'Twitchtv-JSON-API-FCC',
		full_name: 'krittiyaclark/Twitchtv-JSON-API-FCC',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Twitchtv-JSON-API-FCC',
		description: 'Use the Twitchtv JSON API.',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Twitchtv-JSON-API-FCC/deployments',
		created_at: '2017-07-08T02:34:05Z',
		updated_at: '2017-07-08T02:36:23Z',
		pushed_at: '2017-07-23T03:23:30Z',
		git_url: 'git://github.com/krittiyaclark/Twitchtv-JSON-API-FCC.git',
		ssh_url: 'git@github.com:krittiyaclark/Twitchtv-JSON-API-FCC.git',
		clone_url: 'https://github.com/krittiyaclark/Twitchtv-JSON-API-FCC.git',
		svn_url: 'https://github.com/krittiyaclark/Twitchtv-JSON-API-FCC',
		homepage: null,
		size: 10,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 150910625,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNTA5MTA2MjU=',
		name: 'ud864',
		full_name: 'krittiyaclark/ud864',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/ud864',
		description:
			"Public repository for code examples used in Udacity's Google Maps APIs course (https://www.udacity.com/course/google-maps-apis--ud864).",
		fork: true,
		url: 'https://api.github.com/repos/krittiyaclark/ud864',
		forks_url: 'https://api.github.com/repos/krittiyaclark/ud864/forks',
		keys_url: 'https://api.github.com/repos/krittiyaclark/ud864/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/ud864/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/ud864/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/ud864/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/ud864/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/ud864/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/ud864/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/ud864/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/ud864/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/ud864/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/ud864/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/ud864/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/ud864/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/ud864/statuses/{sha}',
		languages_url: 'https://api.github.com/repos/krittiyaclark/ud864/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/ud864/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/ud864/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/ud864/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/ud864/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/ud864/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/ud864/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/ud864/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/ud864/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/ud864/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/ud864/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/ud864/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/ud864/{archive_format}{/ref}',
		downloads_url: 'https://api.github.com/repos/krittiyaclark/ud864/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/ud864/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/ud864/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/ud864/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/ud864/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/ud864/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/ud864/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/ud864/deployments',
		created_at: '2018-09-29T23:19:56Z',
		updated_at: '2018-09-29T23:19:58Z',
		pushed_at: '2018-09-20T15:25:57Z',
		git_url: 'git://github.com/krittiyaclark/ud864.git',
		ssh_url: 'git@github.com:krittiyaclark/ud864.git',
		clone_url: 'https://github.com/krittiyaclark/ud864.git',
		svn_url: 'https://github.com/krittiyaclark/ud864',
		homepage: null,
		size: 44,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: {
			key: 'other',
			name: 'Other',
			spdx_id: 'NOASSERTION',
			url: null,
			node_id: 'MDc6TGljZW5zZTA=',
		},
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 131374382,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzEzNzQzODI=',
		name: 'Udacity-Build-a-Portfolio-Site',
		full_name: 'krittiyaclark/Udacity-Build-a-Portfolio-Site',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Udacity-Build-a-Portfolio-Site',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Build-a-Portfolio-Site/deployments',
		created_at: '2018-04-28T04:58:47Z',
		updated_at: '2018-05-01T02:24:38Z',
		pushed_at: '2018-05-01T02:24:37Z',
		git_url:
			'git://github.com/krittiyaclark/Udacity-Build-a-Portfolio-Site.git',
		ssh_url: 'git@github.com:krittiyaclark/Udacity-Build-a-Portfolio-Site.git',
		clone_url:
			'https://github.com/krittiyaclark/Udacity-Build-a-Portfolio-Site.git',
		svn_url: 'https://github.com/krittiyaclark/Udacity-Build-a-Portfolio-Site',
		homepage: null,
		size: 6040,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'CSS',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 136231725,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzYyMzE3MjU=',
		name: 'Udacity-Front-End-Arcade-Game',
		full_name: 'krittiyaclark/Udacity-Front-End-Arcade-Game',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Udacity-Front-End-Arcade-Game',
		description:
			'Udacity, the front-end project build an Arcade-Game clone with Object-Oriented JavaScript code.',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Arcade-Game/deployments',
		created_at: '2018-06-05T20:33:57Z',
		updated_at: '2018-07-03T03:02:27Z',
		pushed_at: '2018-06-09T14:17:58Z',
		git_url: 'git://github.com/krittiyaclark/Udacity-Front-End-Arcade-Game.git',
		ssh_url: 'git@github.com:krittiyaclark/Udacity-Front-End-Arcade-Game.git',
		clone_url:
			'https://github.com/krittiyaclark/Udacity-Front-End-Arcade-Game.git',
		svn_url: 'https://github.com/krittiyaclark/Udacity-Front-End-Arcade-Game',
		homepage: 'https://krittiyaclark.github.io/Udacity-Front-End-Arcade-Game',
		size: 208,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 137940299,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzc5NDAyOTk=',
		name: 'Udacity-Front-End-Cat-Clicker',
		full_name: 'krittiyaclark/Udacity-Front-End-Cat-Clicker',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Udacity-Front-End-Cat-Clicker',
		description: 'Simple click count using Vanilla JavaScript ',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Cat-Clicker/deployments',
		created_at: '2018-06-19T20:08:37Z',
		updated_at: '2018-06-28T03:11:35Z',
		pushed_at: '2018-06-28T03:11:34Z',
		git_url: 'git://github.com/krittiyaclark/Udacity-Front-End-Cat-Clicker.git',
		ssh_url: 'git@github.com:krittiyaclark/Udacity-Front-End-Cat-Clicker.git',
		clone_url:
			'https://github.com/krittiyaclark/Udacity-Front-End-Cat-Clicker.git',
		svn_url: 'https://github.com/krittiyaclark/Udacity-Front-End-Cat-Clicker',
		homepage: '',
		size: 648,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 137529252,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzc1MjkyNTI=',
		name: 'Udacity-Front-End-Feed-Reader',
		full_name: 'krittiyaclark/Udacity-Front-End-Feed-Reader',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Udacity-Front-End-Feed-Reader',
		description:
			'Udacity: Front-End Web development, use Jasmine to write a number of tests against a pre-existing application.',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Feed-Reader/deployments',
		created_at: '2018-06-15T20:28:47Z',
		updated_at: '2018-06-20T20:39:11Z',
		pushed_at: '2018-06-20T20:39:09Z',
		git_url: 'git://github.com/krittiyaclark/Udacity-Front-End-Feed-Reader.git',
		ssh_url: 'git@github.com:krittiyaclark/Udacity-Front-End-Feed-Reader.git',
		clone_url:
			'https://github.com/krittiyaclark/Udacity-Front-End-Feed-Reader.git',
		svn_url: 'https://github.com/krittiyaclark/Udacity-Front-End-Feed-Reader',
		homepage: '',
		size: 48,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 151177472,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNTExNzc0NzI=',
		name: 'udacity-front-end-neighborhood-map-react',
		full_name: 'krittiyaclark/udacity-front-end-neighborhood-map-react',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/udacity-front-end-neighborhood-map-react',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-neighborhood-map-react/deployments',
		created_at: '2018-10-02T00:04:52Z',
		updated_at: '2018-12-09T04:58:45Z',
		pushed_at: '2018-12-09T04:58:44Z',
		git_url:
			'git://github.com/krittiyaclark/udacity-front-end-neighborhood-map-react.git',
		ssh_url:
			'git@github.com:krittiyaclark/udacity-front-end-neighborhood-map-react.git',
		clone_url:
			'https://github.com/krittiyaclark/udacity-front-end-neighborhood-map-react.git',
		svn_url:
			'https://github.com/krittiyaclark/udacity-front-end-neighborhood-map-react',
		homepage:
			'https://krittiyaclark.github.io/udacity-front-end-neighborhood-map-react/',
		size: 714,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 149913562,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNDk5MTM1NjI=',
		name: 'udacity-front-end-React-MyReads-Project',
		full_name: 'krittiyaclark/udacity-front-end-React-MyReads-Project',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/udacity-front-end-React-MyReads-Project',
		description: null,
		fork: true,
		url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/udacity-front-end-React-MyReads-Project/deployments',
		created_at: '2018-09-22T20:09:10Z',
		updated_at: '2019-01-03T14:56:29Z',
		pushed_at: '2018-12-09T04:00:28Z',
		git_url:
			'git://github.com/krittiyaclark/udacity-front-end-React-MyReads-Project.git',
		ssh_url:
			'git@github.com:krittiyaclark/udacity-front-end-React-MyReads-Project.git',
		clone_url:
			'https://github.com/krittiyaclark/udacity-front-end-React-MyReads-Project.git',
		svn_url:
			'https://github.com/krittiyaclark/udacity-front-end-React-MyReads-Project',
		homepage:
			'https://krittiyaclark.github.io/udacity-front-end-React-MyReads-Project/#/',
		size: 1026,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 142354083,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNDIzNTQwODM=',
		name: 'Udacity-Front-End-Restaurant-Reviews',
		full_name: 'krittiyaclark/Udacity-Front-End-Restaurant-Reviews',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/Udacity-Front-End-Restaurant-Reviews',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Restaurant-Reviews/deployments',
		created_at: '2018-07-25T21:07:32Z',
		updated_at: '2018-08-11T01:49:44Z',
		pushed_at: '2018-08-11T01:49:43Z',
		git_url:
			'git://github.com/krittiyaclark/Udacity-Front-End-Restaurant-Reviews.git',
		ssh_url:
			'git@github.com:krittiyaclark/Udacity-Front-End-Restaurant-Reviews.git',
		clone_url:
			'https://github.com/krittiyaclark/Udacity-Front-End-Restaurant-Reviews.git',
		svn_url:
			'https://github.com/krittiyaclark/Udacity-Front-End-Restaurant-Reviews',
		homepage: null,
		size: 1135,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 131060048,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzEwNjAwNDg=',
		name: 'Udacity-Front-End-Webdevelopment',
		full_name: 'krittiyaclark/Udacity-Front-End-Webdevelopment',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/Udacity-Front-End-Webdevelopment',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Front-End-Webdevelopment/deployments',
		created_at: '2018-04-25T20:29:54Z',
		updated_at: '2018-04-28T04:34:09Z',
		pushed_at: '2018-04-28T04:34:08Z',
		git_url:
			'git://github.com/krittiyaclark/Udacity-Front-End-Webdevelopment.git',
		ssh_url:
			'git@github.com:krittiyaclark/Udacity-Front-End-Webdevelopment.git',
		clone_url:
			'https://github.com/krittiyaclark/Udacity-Front-End-Webdevelopment.git',
		svn_url:
			'https://github.com/krittiyaclark/Udacity-Front-End-Webdevelopment',
		homepage: null,
		size: 9334,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 132812040,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzI4MTIwNDA=',
		name: 'Udacity-Memory-Game',
		full_name: 'krittiyaclark/Udacity-Memory-Game',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Udacity-Memory-Game',
		description: 'Udacity front-end web development project',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-Memory-Game/deployments',
		created_at: '2018-05-09T20:57:02Z',
		updated_at: '2018-05-22T17:00:43Z',
		pushed_at: '2018-05-22T17:00:42Z',
		git_url: 'git://github.com/krittiyaclark/Udacity-Memory-Game.git',
		ssh_url: 'git@github.com:krittiyaclark/Udacity-Memory-Game.git',
		clone_url: 'https://github.com/krittiyaclark/Udacity-Memory-Game.git',
		svn_url: 'https://github.com/krittiyaclark/Udacity-Memory-Game',
		homepage: 'http://threatening-mass.surge.sh',
		size: 53,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 1,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 1,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 121153872,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMjExNTM4NzI=',
		name: 'udacity-project-pixel-art-maker',
		full_name: 'krittiyaclark/udacity-project-pixel-art-maker',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/udacity-project-pixel-art-maker',
		description: 'Udacity Pixel art maker final project',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker/deployments',
		created_at: '2018-02-11T18:30:49Z',
		updated_at: '2018-02-11T21:29:34Z',
		pushed_at: '2018-02-15T04:15:17Z',
		git_url:
			'git://github.com/krittiyaclark/udacity-project-pixel-art-maker.git',
		ssh_url: 'git@github.com:krittiyaclark/udacity-project-pixel-art-maker.git',
		clone_url:
			'https://github.com/krittiyaclark/udacity-project-pixel-art-maker.git',
		svn_url: 'https://github.com/krittiyaclark/udacity-project-pixel-art-maker',
		homepage: null,
		size: 5,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 132283885,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzIyODM4ODU=',
		name: 'udacity-project-pixel-art-maker-vanila-JS',
		full_name: 'krittiyaclark/udacity-project-pixel-art-maker-vanila-JS',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url:
			'https://github.com/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS',
		description: null,
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS/deployments',
		created_at: '2018-05-05T20:56:49Z',
		updated_at: '2018-05-06T05:38:23Z',
		pushed_at: '2018-05-06T05:38:22Z',
		git_url:
			'git://github.com/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS.git',
		ssh_url:
			'git@github.com:krittiyaclark/udacity-project-pixel-art-maker-vanila-JS.git',
		clone_url:
			'https://github.com/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS.git',
		svn_url:
			'https://github.com/krittiyaclark/udacity-project-pixel-art-maker-vanila-JS',
		homepage: null,
		size: 3,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 145351252,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNDUzNTEyNTI=',
		name: 'Udacity-React-Contacts',
		full_name: 'krittiyaclark/Udacity-React-Contacts',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Udacity-React-Contacts',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-React-Contacts/deployments',
		created_at: '2018-08-20T01:26:47Z',
		updated_at: '2018-09-05T03:25:02Z',
		pushed_at: '2018-09-05T03:25:01Z',
		git_url: 'git://github.com/krittiyaclark/Udacity-React-Contacts.git',
		ssh_url: 'git@github.com:krittiyaclark/Udacity-React-Contacts.git',
		clone_url: 'https://github.com/krittiyaclark/Udacity-React-Contacts.git',
		svn_url: 'https://github.com/krittiyaclark/Udacity-React-Contacts',
		homepage: null,
		size: 326,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 139068509,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzkwNjg1MDk=',
		name: 'Udacity-The-Resume-Project',
		full_name: 'krittiyaclark/Udacity-The-Resume-Project',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Udacity-The-Resume-Project',
		description:
			'Store your resume data in four javaScript objects according to the schema given ',
		fork: false,
		url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Udacity-The-Resume-Project/deployments',
		created_at: '2018-06-28T21:09:02Z',
		updated_at: '2018-07-03T03:18:51Z',
		pushed_at: '2018-07-03T03:14:24Z',
		git_url: 'git://github.com/krittiyaclark/Udacity-The-Resume-Project.git',
		ssh_url: 'git@github.com:krittiyaclark/Udacity-The-Resume-Project.git',
		clone_url:
			'https://github.com/krittiyaclark/Udacity-The-Resume-Project.git',
		svn_url: 'https://github.com/krittiyaclark/Udacity-The-Resume-Project',
		homepage: 'https://krittiyaclark.github.io/Udacity-The-Resume-Project/',
		size: 445,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 175893596,
		node_id: 'MDEwOlJlcG9zaXRvcnkxNzU4OTM1OTY=',
		name: 'ux_ui_credentials',
		full_name: 'krittiyaclark/ux_ui_credentials',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/ux_ui_credentials',
		description: 'The Login form was created with React',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/ux_ui_credentials',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/ux_ui_credentials/deployments',
		created_at: '2019-03-15T21:29:30Z',
		updated_at: '2019-03-22T20:28:22Z',
		pushed_at: '2020-06-06T14:03:43Z',
		git_url: 'git://github.com/krittiyaclark/ux_ui_credentials.git',
		ssh_url: 'git@github.com:krittiyaclark/ux_ui_credentials.git',
		clone_url: 'https://github.com/krittiyaclark/ux_ui_credentials.git',
		svn_url: 'https://github.com/krittiyaclark/ux_ui_credentials',
		homepage: 'https://krittiyaclark.github.io/ux_ui_credentials/#/',
		size: 1246,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: true,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 8,
		license: null,
		forks: 0,
		open_issues: 8,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 208817038,
		node_id: 'MDEwOlJlcG9zaXRvcnkyMDg4MTcwMzg=',
		name: 'web-themes',
		full_name: 'krittiyaclark/web-themes',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/web-themes',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/web-themes',
		forks_url: 'https://api.github.com/repos/krittiyaclark/web-themes/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/krittiyaclark/web-themes/teams',
		hooks_url: 'https://api.github.com/repos/krittiyaclark/web-themes/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/issues/events{/number}',
		events_url: 'https://api.github.com/repos/krittiyaclark/web-themes/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/branches{/branch}',
		tags_url: 'https://api.github.com/repos/krittiyaclark/web-themes/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/krittiyaclark/web-themes/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/web-themes/deployments',
		created_at: '2019-09-16T14:13:00Z',
		updated_at: '2019-09-16T15:36:37Z',
		pushed_at: '2019-09-16T15:36:35Z',
		git_url: 'git://github.com/krittiyaclark/web-themes.git',
		ssh_url: 'git@github.com:krittiyaclark/web-themes.git',
		clone_url: 'https://github.com/krittiyaclark/web-themes.git',
		svn_url: 'https://github.com/krittiyaclark/web-themes',
		homepage: null,
		size: 10016,
		stargazers_count: 0,
		watchers_count: 0,
		language: null,
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 95070443,
		node_id: 'MDEwOlJlcG9zaXRvcnk5NTA3MDQ0Mw==',
		name: 'Wikipedia-Search-Engine',
		full_name: 'krittiyaclark/Wikipedia-Search-Engine',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/Wikipedia-Search-Engine',
		description:
			'FCC assignment, build Wikipedia Search Engine by using JSON, AJAX and API. ',
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/Wikipedia-Search-Engine/deployments',
		created_at: '2017-06-22T03:25:33Z',
		updated_at: '2017-06-22T03:32:27Z',
		pushed_at: '2017-07-04T19:41:59Z',
		git_url: 'git://github.com/krittiyaclark/Wikipedia-Search-Engine.git',
		ssh_url: 'git@github.com:krittiyaclark/Wikipedia-Search-Engine.git',
		clone_url: 'https://github.com/krittiyaclark/Wikipedia-Search-Engine.git',
		svn_url: 'https://github.com/krittiyaclark/Wikipedia-Search-Engine',
		homepage: null,
		size: 3,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'HTML',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 1,
		license: null,
		forks: 0,
		open_issues: 1,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 193025661,
		node_id: 'MDEwOlJlcG9zaXRvcnkxOTMwMjU2NjE=',
		name: 'wordpress-first-theme',
		full_name: 'krittiyaclark/wordpress-first-theme',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/wordpress-first-theme',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/krittiyaclark/wordpress-first-theme',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/wordpress-first-theme/deployments',
		created_at: '2019-06-21T03:39:54Z',
		updated_at: '2019-07-25T15:43:11Z',
		pushed_at: '2020-07-17T09:54:53Z',
		git_url: 'git://github.com/krittiyaclark/wordpress-first-theme.git',
		ssh_url: 'git@github.com:krittiyaclark/wordpress-first-theme.git',
		clone_url: 'https://github.com/krittiyaclark/wordpress-first-theme.git',
		svn_url: 'https://github.com/krittiyaclark/wordpress-first-theme',
		homepage: null,
		size: 25291,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'PHP',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 3,
		license: null,
		forks: 0,
		open_issues: 3,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 139904130,
		node_id: 'MDEwOlJlcG9zaXRvcnkxMzk5MDQxMzA=',
		name: 'You-Dont-Know-JS',
		full_name: 'krittiyaclark/You-Dont-Know-JS',
		private: false,
		owner: {
			login: 'krittiyaclark',
			id: 3038228,
			node_id: 'MDQ6VXNlcjMwMzgyMjg=',
			avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/krittiyaclark',
			html_url: 'https://github.com/krittiyaclark',
			followers_url: 'https://api.github.com/users/krittiyaclark/followers',
			following_url:
				'https://api.github.com/users/krittiyaclark/following{/other_user}',
			gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/krittiyaclark/subscriptions',
			organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
			repos_url: 'https://api.github.com/users/krittiyaclark/repos',
			events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/krittiyaclark/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/krittiyaclark/You-Dont-Know-JS',
		description: 'A book series on JavaScript. @YDKJS on twitter.',
		fork: true,
		url: 'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS',
		forks_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/forks',
		keys_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/teams',
		hooks_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/hooks',
		issue_events_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/events',
		assignees_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/branches{/branch}',
		tags_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/tags',
		blobs_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/languages',
		stargazers_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/stargazers',
		contributors_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/contributors',
		subscribers_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/subscribers',
		subscription_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/subscription',
		commits_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/merges',
		archive_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/downloads',
		issues_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/labels{/name}',
		releases_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/krittiyaclark/You-Dont-Know-JS/deployments',
		created_at: '2018-07-05T21:51:40Z',
		updated_at: '2018-07-05T21:51:42Z',
		pushed_at: '2018-07-05T11:17:54Z',
		git_url: 'git://github.com/krittiyaclark/You-Dont-Know-JS.git',
		ssh_url: 'git@github.com:krittiyaclark/You-Dont-Know-JS.git',
		clone_url: 'https://github.com/krittiyaclark/You-Dont-Know-JS.git',
		svn_url: 'https://github.com/krittiyaclark/You-Dont-Know-JS',
		homepage:
			'http://www.kickstarter.com/projects/getify/you-dont-know-js-book-series',
		size: 7307,
		stargazers_count: 0,
		watchers_count: 0,
		language: null,
		has_issues: false,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: {
			key: 'other',
			name: 'Other',
			spdx_id: 'NOASSERTION',
			url: null,
			node_id: 'MDc6TGljZW5zZTA=',
		},
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
]